import { render, staticRenderFns } from "./OsobaRazdobljeForma.vue?vue&type=template&id=58153dfb&scoped=true&"
import script from "./OsobaRazdobljeForma.vue?vue&type=script&lang=js&"
export * from "./OsobaRazdobljeForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58153dfb",
  null
  
)

export default component.exports